import { Component, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { Departamento, Dispositivo, Empregador, Funcionario, JornadaPonto } from '../api.service';
import { AlertaMensagemComponent } from '../shared/alerta-mensagem.component';
import { ServicoFormatacao } from '../shared/servico-formatacao';
import { ServicoIdentidadeMarca } from '../shared/servico-identidade-marca';
import { ServicoMensagemAplicacao } from '../shared/servico-mensagem-aplicacao';
import { TelaLoginComponent } from '../features/login/tela-login.component';
import { TelaRegistradorComponent } from '../features/registrador/tela-registrador.component';
import { TelaEmpregadorComponent } from '../features/empregador/tela-empregador.component';
import { ServicoEmpregadorAdministrativo } from '../features/empregador/servico-empregador-administrativo';
import { TelaDepartamentosComponent } from '../features/departamentos/tela-departamentos.component';
import { ServicoDepartamentoAdministrativo } from '../features/departamentos/servico-departamento-administrativo';
import { TelaFuncionarioComponent } from '../features/funcionario/tela-funcionario.component';
import { ServicoFuncionarioAdministrativo } from '../features/funcionario/servico-funcionario-administrativo';
import { TelaRelogioComponent } from '../features/relogio/tela-relogio.component';
import { ServicoRelogioPonto } from '../features/relogio/servico-relogio-ponto';
import { ServicoTerminalRelogio } from '../features/relogio/servico-terminal-relogio';
import { TelaExportacaoComponent } from '../features/exportacao/tela-exportacao.component';
import { TelaPendenciaPontoComponent } from '../features/pendencias/tela-pendencia-ponto.component';
import { TelaUsuariosComponent } from '../features/usuarios/tela-usuarios.component';
import { TelaAuditoriaComponent } from '../features/auditoria/tela-auditoria.component';
import { TelaSolicitacoesComponent } from '../features/solicitacoes/tela-solicitacoes.component';
import { ServicoSolicitacaoAdministrativa } from '../features/solicitacoes/servico-solicitacao-administrativa';
import { ServicoAutenticacao } from '../core/auth/servico-autenticacao';
import { AbaAdministrativa, ServicoNavegacaoAdministrativa } from '../core/rotas/servico-navegacao-administrativa';
import { EstadoTerminalPublico, ServicoTerminalPublico } from '../core/terminal/servico-terminal-publico';
import { LayoutAdministrativoComponent } from './layout-administrativo.component';
import { LayoutTerminalComponent } from './layout-terminal.component';
import { EstadoAdministrativoShell, ServicoEstadoAdministrativoShell } from './servico-estado-administrativo-shell';
import { AcaoInicializacaoShell, ServicoInicializacaoShell } from './servico-inicializacao-shell';
import { ServicoTenantShell } from './servico-tenant-shell';

type RelogioAba = 'horarios' | 'jornadas' | 'terminais';
@Component({
  selector: 'app-shell-aplicacao',
  standalone: true,
  imports: [
    CommonModule,
    AlertaMensagemComponent,
    LayoutAdministrativoComponent,
    LayoutTerminalComponent,
    TelaLoginComponent,
    TelaRegistradorComponent,
    TelaEmpregadorComponent,
    TelaDepartamentosComponent,
    TelaFuncionarioComponent,
    TelaRelogioComponent,
    TelaExportacaoComponent,
    TelaPendenciaPontoComponent,
    TelaUsuariosComponent,
    TelaAuditoriaComponent,
    TelaSolicitacoesComponent
  ],
  templateUrl: './shell-aplicacao.component.html'
})
export class ShellAplicacaoComponent implements OnInit, OnDestroy {
  aba: AbaAdministrativa = 'registrador';
  relogioAba: RelogioAba = 'horarios';
  agora = new Date();
  empregadores: Empregador[] = [];
  funcionarios: Funcionario[] = [];
  departamentos: Departamento[] = [];
  dispositivos: Dispositivo[] = [];
  jornadas: JornadaPonto[] = [];
  terminalPublico = false;
  estadoTerminalPublico: EstadoTerminalPublico = this.servicoTerminalPublico.estadoVazio();
  codigoAtivacaoTerminal = '';
  ativandoTerminal = false;
  dispositivo: Dispositivo = this.novoDispositivo();
  loginForm = { email: '', senha: '' };
  primeiroAcesso = false;
  private atualizacaoRelogio?: number;
  private atualizacaoTerminalPublico?: number;
  private assinaturaRoteador?: Subscription;

  empregador: Empregador = this.novoEmpregador();
  relogioEmpregador: Empregador = this.novoEmpregador();
  jornadaPonto: JornadaPonto = this.novaJornadaPonto();
  funcionario: Funcionario = this.novoFuncionario();
  empregadorSelecionado = '';
  funcionarioCadastroSelecionado = '';
  buscaFuncionarioCadastro = '';
  ajustesPendentes = 0;
  feriasPendentes = 0;
  constructor(
    private readonly servicoAutenticacao: ServicoAutenticacao,
    private readonly servicoTerminalPublico: ServicoTerminalPublico,
    private readonly servicoFormatacao: ServicoFormatacao,
    private readonly servicoIdentidadeMarca: ServicoIdentidadeMarca,
    private readonly servicoMensagemAplicacao: ServicoMensagemAplicacao,
    private readonly servicoEmpregadorAdministrativo: ServicoEmpregadorAdministrativo,
    private readonly servicoDepartamentoAdministrativo: ServicoDepartamentoAdministrativo,
    private readonly servicoFuncionarioAdministrativo: ServicoFuncionarioAdministrativo,
    private readonly servicoRelogioPonto: ServicoRelogioPonto,
    private readonly servicoTerminalRelogio: ServicoTerminalRelogio,
    private readonly servicoNavegacaoAdministrativa: ServicoNavegacaoAdministrativa,
    private readonly servicoEstadoAdministrativoShell: ServicoEstadoAdministrativoShell,
    private readonly servicoInicializacaoShell: ServicoInicializacaoShell,
    private readonly servicoTenantShell: ServicoTenantShell,
    private readonly servicoSolicitacaoAdministrativa: ServicoSolicitacaoAdministrativa,
    private readonly roteador: Router
  ) {}

  get mensagem() {
    return this.servicoMensagemAplicacao.texto;
  }

  set mensagem(valor: string) {
    this.servicoMensagemAplicacao.mostrar(valor);
  }

  get usuarioLogado() {
    return this.servicoAutenticacao.usuarioLogado;
  }

  ngOnInit() {
    this.atualizacaoRelogio = window.setInterval(() => this.agora = new Date(), 1000);
    this.sincronizarAbaComRota(window.location.pathname);
    this.assinaturaRoteador = this.roteador.events
      .pipe(filter((evento): evento is NavigationEnd => evento instanceof NavigationEnd))
      .subscribe(evento => this.sincronizarAbaComRota(evento.urlAfterRedirects));

    this.executarAcaoInicial(this.servicoInicializacaoShell.acaoInicial());
  }

  private executarAcaoInicial(acao: AcaoInicializacaoShell) {
    if (acao === 'terminal-publico') {
      this.carregarTenantPublico();
      return;
    }

    if (acao === 'sessao-token') {
      this.carregarSessao();
      return;
    }

    this.carregarIdentidadeTenantLogin();
    this.verificarPrimeiroAcesso();
  }

  entrar() {
    this.servicoAutenticacao.entrar(this.loginForm.email, this.loginForm.senha).subscribe({
      next: response => {
        this.aplicarLogin();
      },
      error: () => this.mensagem = 'Usuario ou senha invalidos.'
    });
  }

  criarPrimeiroAcesso() {
    this.servicoAutenticacao.criarPrimeiroAcesso(
      this.servicoAutenticacao.montarUsuarioPrimeiroAcesso(this.loginForm.email, this.loginForm.senha)
    ).subscribe({
      next: response => {
        this.aplicarLogin();
      },
      error: erro => {
        this.primeiroAcesso = false;
        this.mensagem = this.servicoMensagemAplicacao.erroApi(erro, 'Nao foi possivel criar o primeiro usuario. Se ja existir usuario, faca login.');
      }
    });
  }

  sair() {
    this.servicoAutenticacao.sair();
    this.limparDadosSessaoAdministrativa();
    this.roteador.navigate(['/login']);
  }

  abrirMenuGerencial() {
    this.roteador.navigate(['/menu']);
  }

  private limparDadosSessaoAdministrativa() {
    this.aplicarEstadoAdministrativo(this.servicoEstadoAdministrativoShell.sessaoAdministrativaLimpa());
  }

  selecionarAbaAdministrativa(aba: string) {
    const proximaAba = aba as AbaAdministrativa;
    this.roteador.navigate([`/${this.servicoNavegacaoAdministrativa.rotaDaAba(proximaAba)}`]);
    this.aplicarAbaAdministrativa(proximaAba);
  }

  private aplicarAbaAdministrativa(aba: AbaAdministrativa) {
    this.aba = aba;
    const carregamentos = this.servicoNavegacaoAdministrativa.carregamentosDaAba(aba);
    if (carregamentos.empregadorCadastro) {
      this.carregarEmpregadorCadastro();
    }
    if (carregamentos.relogio) {
      this.relogioAba = 'horarios';
      this.carregarRelogioEmpregador();
    }
    if (carregamentos.jornadas) {
      this.carregarJornadas();
    }
    if (carregamentos.terminais) {
      this.carregarDispositivos();
    }
    if (carregamentos.funcionariosExportacao) {
      this.carregarFuncionariosLista();
    }
    if (carregamentos.departamentos) {
      this.carregarDepartamentos();
    }
  }

  private sincronizarAbaComRota(url: string) {
    const proximaAba = this.servicoNavegacaoAdministrativa.abaPorUrl(url);
    if (!this.servicoNavegacaoAdministrativa.podeAcessarAba(proximaAba, this.usuarioLogado, this.terminalPublico)) {
      this.aba = 'registrador';
      this.mensagem = 'Acesso permitido apenas para administrador global.';
      this.abrirMenuGerencial();
      return;
    }
    this.aba = proximaAba;
    if (!this.terminalPublico && this.usuarioLogado) {
      this.aplicarAbaAdministrativa(proximaAba);
    }
  }

  private carregarSessao() {
    this.servicoAutenticacao.carregarSessao().subscribe({
      next: usuario => {
        if (usuario.perfil === 'SERVIDOR') {
          this.roteador.navigate(['/servidor']);
          return;
        }
        this.primeiroAcesso = false;
        this.carregarDados();
      },
      error: () => {
        this.servicoAutenticacao.sair();
        this.verificarPrimeiroAcesso();
      }
    });
  }

  private verificarPrimeiroAcesso() {
    this.servicoAutenticacao.verificarPrimeiroAcesso().subscribe({
      next: disponivel => this.primeiroAcesso = disponivel,
      error: () => this.primeiroAcesso = false
    });
  }

  private aplicarLogin() {
    this.limparFormularioLoginAutenticado();
    if (this.usuarioLogado?.perfil === 'SERVIDOR') {
      this.roteador.navigate(['/servidor']);
      return;
    }
    if (this.servicoNavegacaoAdministrativa.ehRotaLogin(window.location.pathname)) {
      this.carregarDados();
      this.abrirMenuGerencial();
      return;
    }
    this.sincronizarAbaComRota(window.location.pathname);
    this.carregarDados();
  }

  private limparFormularioLoginAutenticado() {
    this.primeiroAcesso = false;
    this.loginForm = { email: '', senha: '' };
  }

  private carregarTenantPublico() {
    this.prepararModoTerminalPublico();
    this.servicoTenantShell.buscarTenantPublico().subscribe({
      next: tenant => this.aplicarIdentidadeTenant(tenant),
      error: erro => {
        this.mensagem = this.servicoMensagemAplicacao.erroApi(erro, 'Terminal nao configurado para este dominio.');
      }
    });
  }

  private prepararModoTerminalPublico() {
    this.terminalPublico = true;
    this.aba = 'registrador';
  }

  private carregarIdentidadeTenantLogin() {
    if (!this.servicoTenantShell.deveCarregarIdentidadeTenantLogin()) {
      return;
    }
    this.servicoTenantShell.buscarTenantPublico().subscribe({
      next: tenant => this.aplicarIdentidadeTenant(tenant),
      error: () => undefined
    });
  }

  private aplicarEstadoAdministrativo(estado: EstadoAdministrativoShell) {
    Object.assign(this, estado);
  }

  private aplicarIdentidadeTenant(tenant: Empregador) {
    this.aplicarEstadoAdministrativo(this.servicoEstadoAdministrativoShell.doTenantPublico(tenant));
    if (this.terminalPublico && this.empregadorSelecionado) {
      this.validarTerminalPublico();
    }
  }

  carregarDados() {
    this.servicoEmpregadorAdministrativo.listarDaSessao(this.usuarioLogado).subscribe({
      next: empregadores => this.aplicarEmpregadoresSessao(empregadores),
      error: () => this.mensagem = 'Nao foi possivel carregar empregadores. Verifique se o backend esta ativo.'
    });
  }

  private aplicarEmpregadoresSessao(empregadores: Empregador[]) {
    this.aplicarEstadoAdministrativo(
      this.servicoEstadoAdministrativoShell.daSessaoEmpregadores(
        empregadores,
        this.empregadorSelecionado,
        this.funcionario
      )
    );
    this.carregarEstruturaEmpregadorSelecionado();
    this.carregarFuncionarios();
    this.carregarResumoSolicitacoes();
  }

  private carregarEstruturaEmpregadorSelecionado() {
    this.carregarEmpregadorCadastro();
    this.carregarRelogioEmpregador();
    this.carregarJornadas();
    this.carregarDispositivos();
    this.carregarDepartamentos();
  }

  carregarDepartamentos() {
    this.servicoDepartamentoAdministrativo.listarPorEmpregadorSelecionado(this.empregadorSelecionado).subscribe({
      next: departamentos => this.departamentos = departamentos,
      error: () => this.mensagem = 'Nao foi possivel carregar departamentos.'
    });
  }

  carregarDispositivos() {
    this.servicoTerminalRelogio.listarPorEmpregadorSelecionado(this.empregadorSelecionado).subscribe({
      next: dispositivos => this.dispositivos = dispositivos,
      error: () => this.mensagem = 'Nao foi possivel carregar terminais.'
    });
  }

  aoLimparTerminal(dispositivo: Dispositivo) {
    this.dispositivo = dispositivo;
  }

  aoSalvarTerminal() {
    this.dispositivo = this.novoDispositivo();
    this.carregarDispositivos();
  }

  aoRevogarTerminal() {
    this.carregarDispositivos();
  }

  ngOnDestroy() {
    if (this.atualizacaoRelogio) {
      window.clearInterval(this.atualizacaoRelogio);
      this.atualizacaoRelogio = undefined;
    }
    this.pararAtualizacaoTerminalPublico();
    this.assinaturaRoteador?.unsubscribe();
  }

  aoExcluirTerminal() {
    this.dispositivo = this.novoDispositivo();
    this.carregarDispositivos();
  }

  carregarFuncionarios() {
    this.servicoFuncionarioAdministrativo.listarPorEmpregadorSelecionado(this.empregadorSelecionado).subscribe({
      next: funcionarios => {
        this.funcionarios = funcionarios;
        if (funcionarios.length === 0) {
          this.novoCadastroFuncionario();
          return;
        }

        if (!this.funcionarioCadastroSelecionado) {
          this.novoCadastroFuncionario();
          return;
        }

        this.funcionarioCadastroSelecionado = this.servicoFuncionarioAdministrativo.selecionarFuncionarioCadastro(
          funcionarios,
          this.funcionarioCadastroSelecionado
        );
        this.carregarFuncionarioCadastro(true);
      },
      error: () => this.mensagem = 'Nao foi possivel carregar funcionarios.'
    });
  }

  aoAlterarEmpregador() {
    this.carregarEstruturaEmpregadorSelecionado();
    this.buscaFuncionarioCadastro = '';
    this.novoCadastroFuncionario();
    this.carregarFuncionarios();
    this.carregarResumoSolicitacoes();
  }

  carregarEmpregadorCadastro() {
    this.aplicarEstadoAdministrativo(
      this.servicoEstadoAdministrativoShell.doEmpregadorCadastro(this.empregadores, this.empregadorSelecionado)
    );
  }

  carregarRelogioEmpregador() {
    this.aplicarEstadoAdministrativo(
      this.servicoEstadoAdministrativoShell.doRelogioEmpregador(this.empregadores, this.empregadorSelecionado)
    );
  }

  carregarJornadas() {
    this.servicoRelogioPonto.listarJornadasPorEmpregadorSelecionado(this.empregadorSelecionado).subscribe({
      next: jornadas => {
        this.jornadas = jornadas.map(jornada => this.servicoRelogioPonto.prepararJornada(jornada));
        this.jornadaPonto = this.servicoRelogioPonto.selecionarJornadaCadastro(this.jornadas, this.empregadorSelecionado);
      },
      error: () => this.mensagem = 'Nao foi possivel carregar jornadas.'
    });
  }

  carregarFuncionariosLista() {
    this.servicoFuncionarioAdministrativo.listarPorEmpregadorSelecionado(this.empregadorSelecionado).subscribe({
      next: funcionarios => this.funcionarios = funcionarios,
      error: () => this.mensagem = 'Nao foi possivel carregar funcionarios.'
    });
  }

  aoAlterarEmpregadorExportacao() {
    this.carregarFuncionariosLista();
    this.carregarJornadas();
    this.carregarDepartamentos();
    this.carregarResumoSolicitacoes();
  }

  carregarResumoSolicitacoes() {
    if (!this.empregadorSelecionado) {
      this.ajustesPendentes = 0;
      this.feriasPendentes = 0;
      return;
    }
    this.servicoSolicitacaoAdministrativa.resumo(this.empregadorSelecionado).subscribe({
      next: resumo => {
        this.ajustesPendentes = resumo.ajustesPendentes;
        this.feriasPendentes = resumo.feriasPendentes;
      },
      error: () => {
        this.ajustesPendentes = 0;
        this.feriasPendentes = 0;
      }
    });
  }

  aoLimparRelogio(relogio: Empregador) {
    this.relogioEmpregador = relogio;
  }

  aoSalvarRelogio(relogio: Empregador) {
    this.relogioEmpregador = this.servicoRelogioPonto.prepararConfiguracao(relogio);
    this.carregarDados();
  }

  aoLimparJornada(jornada: JornadaPonto) {
    this.jornadaPonto = jornada;
  }

  aoSalvarJornada(jornada: JornadaPonto) {
    this.jornadaPonto = this.servicoRelogioPonto.prepararJornada(jornada);
    this.carregarJornadas();
  }

  aoExcluirJornada() {
    this.jornadaPonto = this.novaJornadaPonto();
    this.carregarJornadas();
  }

  carregarFuncionarioCadastro(silencioso = false) {
    this.servicoFuncionarioAdministrativo.carregarFuncionarioCadastro(
      this.funcionarios,
      this.funcionarioCadastroSelecionado,
      this.empregadorSelecionado
    ).subscribe({
      next: funcionario => {
        if (!funcionario) {
          this.novoCadastroFuncionario();
          return;
        }
        this.funcionario = funcionario;
        if (!silencioso) {
          this.mensagem = this.servicoFuncionarioAdministrativo.mensagemFuncionarioCarregado(funcionario);
        }
      },
      error: () => this.mensagem = this.servicoFuncionarioAdministrativo.mensagemErroCarregar()
    });
  }

  novoCadastroFuncionario() {
    this.funcionarioCadastroSelecionado = '';
    this.funcionario = this.novoFuncionario();
    this.funcionario.empregadorId = this.empregadorSelecionado;
  }

  aoLimparEmpregador(empregador: Empregador) {
    this.empregadorSelecionado = '';
    this.empregador = empregador;
    this.limparDadosDependentesEmpregador();
  }

  private limparDadosDependentesEmpregador() {
    this.aplicarEstadoAdministrativo(
      this.servicoEstadoAdministrativoShell.dependenciasEmpregadorLimpas(this.empregadorSelecionado)
    );
  }

  aoSalvarEmpregador(empregador: Empregador) {
    this.empregadorSelecionado = empregador.id || this.empregadorSelecionado;
    this.empregador = this.servicoEmpregadorAdministrativo.prepararCadastro(empregador);
    this.carregarDados();
  }

  aoExcluirEmpregador() {
    this.empregadorSelecionado = '';
    this.empregador = this.novoEmpregador();
    this.carregarDados();
  }

  aoLimparFuncionario(funcionario: Funcionario) {
    this.funcionarioCadastroSelecionado = '';
    this.funcionario = funcionario;
    this.funcionario.empregadorId = this.empregadorSelecionado;
  }

  aoSalvarFuncionario(funcionario: Funcionario) {
    this.funcionario = funcionario;
    this.funcionario.empregadorId = this.empregadorSelecionado;
    this.funcionarioCadastroSelecionado = funcionario.id || '';
    this.carregarFuncionarios();
  }

  aoExcluirFuncionario() {
    this.novoCadastroFuncionario();
    this.carregarFuncionarios();
  }

  selecionarEmpregadorBusca(empregador: Empregador) {
    this.empregadorSelecionado = empregador.id || '';
    this.aoAlterarEmpregador();
  }

  selecionarEmpregadorBuscaGenerico(item: unknown) {
    this.selecionarEmpregadorBusca(item as Empregador);
  }

  aoSelecionarFuncionario(funcionario: Funcionario) {
    this.funcionario = funcionario;
    this.funcionarioCadastroSelecionado = funcionario.id || '';
  }

  get terminalAutorizado() {
    return this.estadoTerminalPublico.autorizado;
  }

  get terminalNome() {
    return this.estadoTerminalPublico.nome;
  }

  get terminalToken() {
    return this.estadoTerminalPublico.tokenTerminal;
  }

  validarTerminalPublico() {
    const persistido = this.servicoTerminalPublico.estadoPersistido();
    if (!persistido) {
      this.estadoTerminalPublico = this.servicoTerminalPublico.estadoVazio();
      this.pararAtualizacaoTerminalPublico();
      return;
    }

    this.aplicarTerminalPublico(persistido);
    this.servicoTerminalPublico.validarTokenSalvo().subscribe({
      next: terminal => {
        this.aplicarTerminalPublico(terminal);
      },
      error: erro => {
        if (this.servicoTerminalPublico.ehRecusaDefinitiva(erro)) {
          this.estadoTerminalPublico = this.servicoTerminalPublico.estadoVazio();
          this.pararAtualizacaoTerminalPublico();
        }
        this.mensagem = this.servicoTerminalPublico.mensagemFalhaValidacao(erro);
      }
    });
  }

  ativarTerminalPublico() {
    if (!this.codigoAtivacaoTerminal.trim()) {
      this.mensagem = 'Informe o codigo de ativacao do terminal.';
      return;
    }

    this.ativandoTerminal = true;
    this.servicoTerminalPublico.ativar(this.codigoAtivacaoTerminal).subscribe({
      next: terminal => {
        this.ativandoTerminal = false;
        this.aplicarTerminalPublico(terminal);
        this.codigoAtivacaoTerminal = '';
        this.mensagem = `Terminal autorizado: ${terminal.nome}.`;
      },
      error: erro => {
        this.ativandoTerminal = false;
        this.mensagem = this.servicoMensagemAplicacao.erroApi(erro, 'Terminal nao autorizado.');
      }
    });
  }

  private aplicarTerminalPublico(terminal: EstadoTerminalPublico) {
    this.estadoTerminalPublico = this.servicoTerminalPublico.estadoAutorizado(terminal);
    this.iniciarAtualizacaoTerminalPublico();
  }

  private iniciarAtualizacaoTerminalPublico() {
    if (!this.terminalPublico || this.atualizacaoTerminalPublico) {
      return;
    }

    this.atualizacaoTerminalPublico = window.setInterval(
      () => this.atualizarTerminalPublicoSilencioso(),
      15000
    );
  }

  private pararAtualizacaoTerminalPublico() {
    if (!this.atualizacaoTerminalPublico) {
      return;
    }

    window.clearInterval(this.atualizacaoTerminalPublico);
    this.atualizacaoTerminalPublico = undefined;
  }

  private atualizarTerminalPublicoSilencioso() {
    if (!this.terminalPublico || !this.servicoTerminalPublico.tokenSalvo) {
      this.pararAtualizacaoTerminalPublico();
      return;
    }

    this.servicoTerminalPublico.validarTokenSalvo().subscribe({
      next: terminal => this.estadoTerminalPublico = this.servicoTerminalPublico.estadoAutorizado(terminal),
      error: erro => {
        if (!this.servicoTerminalPublico.ehRecusaDefinitiva(erro)) {
          return;
        }
        this.estadoTerminalPublico = this.servicoTerminalPublico.estadoVazio();
        this.pararAtualizacaoTerminalPublico();
        this.mensagem = this.servicoTerminalPublico.mensagemFalhaValidacao(erro);
      }
    });
  }

  get isAdminGlobal() {
    return this.servicoNavegacaoAdministrativa.ehAdministradorGlobal(this.usuarioLogado);
  }

  get urlTerminalEmpregador() {
    const tenant = this.servicoEmpregadorAdministrativo.normalizarTenant(this.empregador.slugTenant || '');
    return tenant ? `https://${tenant}.jwmtecnologia.com.br` : '';
  }

  get nomeEmpresaHeader() {
    return this.identidadeMarca.nome;
  }

  get logoEmpresaHeader() {
    return this.identidadeMarca.logo;
  }

  get iniciaisEmpresaHeader() {
    return this.identidadeMarca.iniciais;
  }

  private get identidadeMarca() {
    return this.servicoIdentidadeMarca.montar(this.empregadores, this.empregadorSelecionado, this.empregador);
  }

  aoDigitarCpfFuncionario() {
    this.funcionario.cpf = this.formatarCpf(this.funcionario.cpf);
  }

  formatarCpf(cpf?: string) {
    return this.servicoFormatacao.formatarCpf(cpf);
  }

  private novoEmpregador(): Empregador {
    return this.servicoEmpregadorAdministrativo.novoEmpregador();
  }

  private novoFuncionario(): Funcionario {
    return this.servicoFuncionarioAdministrativo.novoFuncionario(this.empregadorSelecionado);
  }

  private novoDispositivo(): Dispositivo {
    return this.servicoTerminalRelogio.novoTerminal(this.empregadorSelecionado);
  }

  private novaJornadaPonto(): JornadaPonto {
    return this.servicoRelogioPonto.novaJornada(this.empregadorSelecionado);
  }

  dataCentralFormatada() {
    return this.servicoFormatacao.formatarDataExtenso(this.agora);
  }

}
